// src/context/paletteSync.js
// ─────────────────────────────────────────────────────────────────────────────
// Bridge between React context (ChartPaletteContext) and imperative code
// (wsShared.js, DashboardEngine, etc.) that reads PALETTE at module scope.
//
// How it works:
//  1. _livePalette is a mutable array that wsShared.js exports as PALETTE.
//  2. PaletteSyncBridge (rendered inside ChartPaletteProvider) copies
//     context colors into _livePalette on every change AND triggers
//     a lightweight re-render signal that workspace labs can subscribe to.
//  3. useLivePalette() returns the current palette + a version counter
//     so React components re-render when it changes.
// ─────────────────────────────────────────────────────────────────────────────

// The shared mutable array — wsShared.js re-exports this.
const STORAGE_KEY = 'jorvex:chartPalette';
const CUSTOM_STORAGE_KEY = 'jorvex:chartPaletteCustom';

function loadInitial() {
  try {
    const id = localStorage.getItem(STORAGE_KEY);
    if (id === 'custom') {
      const raw = localStorage.getItem(CUSTOM_STORAGE_KEY);
      if (raw) { const p = JSON.parse(raw); if (Array.isArray(p) && p.length >= 2) return p; }
    }
    // For any preset or default, return defaults — the context will override immediately.
  } catch (_) { /* ignore */ }
  return ['#22d3ee','#4ade80','#a78bfa','#fbbf24','#fb923c','#f87171','#f472b6','#60a5fa','#34d399','#67e8f9'];
}

export const _livePalette = loadInitial();

// Listeners for non-context React components that just need the array
let _version = 0;
const _listeners = new Set();

export function subscribePalette(fn) { _listeners.add(fn); return () => _listeners.delete(fn); }
export function getPaletteVersion() { return _version; }

export function syncPalette(colors) {
  _livePalette.length = 0;
  colors.forEach(c => _livePalette.push(c));
  _version++;
  _listeners.forEach(fn => fn(_livePalette, _version));
}
